import { getEntgeltTransPPage, FSPage } from 'fs_design_system'
import Chart from 'chart.js/auto'
import { Report } from '../../shared/model/models'
import CompanyLogo from '../../assets/company/Logo.png'
import CoverBG from '../../assets/entgelreport/cover.png'
import FairSolutionLogo from '../../assets/Logo_FAIR.png'
import OverviewImg from '../../assets/entgelreport/overview.png'

const EntgeltTransP = ({
  data,
  pageNumber = 1,
  scale = 0.5,
  setIndexPages,
  setTotalPages,
}: {
  data: Report
  pageNumber?: number
  scale?: number
  setIndexPages: any
  setTotalPages: any
}) => {
  const indexPages = data?.reportData?.index?.pages ?? 0
  const totalPages = (data?.reportData?.pages?.length ?? 0) + (indexPages ?? 0) + 2

  setIndexPages(indexPages)
  setTotalPages(totalPages)

  const canvas = document.createElement('canvas')
  canvas.width = 1200
  canvas.height = 900

  return (
    <div
      style={{
        width: `${1240 * scale}px`,
        height: `${1754 * scale}px`,
        margin: 'auto',
      }}
    >
      <FSPage mode="browser" scale={scale}>
        {getEntgeltTransPPage(data, 'browser', pageNumber, canvas, Chart, [
          CompanyLogo,
          CoverBG,
          FairSolutionLogo,
          OverviewImg,
        ])}
      </FSPage>
    </div>
  )
}

export default EntgeltTransP
